import createReactComponent from '../createReactComponent';
var Beaker = createReactComponent('Beaker', [['path', {
  d: 'M4.5 3h15',
  key: 'c7n0jr'
}], ['path', {
  d: 'M6 3v16a2 2 0 002 2h8a2 2 0 002-2V3',
  key: 'rkxg6z'
}], ['path', {
  d: 'M6 14h12',
  key: '4cwo0f'
}]]);
export default Beaker;